import React from 'react'
import { injectIntl } from "gatsby-plugin-intl"

class SecTitle extends React.Component {

    render() {
        const { intl } = this.props
        const title = `${this.props.type}.${this.props.title}.title`
        const subTitleList = JSON.parse(intl.formatMessage({id:`${this.props.type}.${this.props.title}.subTitleList`}))

        return (
                <div className="row box-header">
                    <h3 className="">
                            { intl.formatMessage({id: title}) }
                    </h3>
                    <div className="box-header-subtext">
                    { subTitleList.map((text, i) => {
                        return ( <p key={i}> {text} </p> )
                    })}
                    </div>
                </div>
        )
    }
}

export default injectIntl(SecTitle)
